<template>
  <div class="my-colleague">
    <el-container class="common-container">
      <el-main class="main">
        <div class="colleague-table">
          <div class="form-title">
            <span>
              我的同事
            </span>
          </div>
          <div class="table-header">
            <span class="header-reminder"><i class="el-icon-warning"></i>最多添加5个同事在首页</span>
            <el-button
              type="primary"
              size="small"
              @click="openDialog"
            >
              <i class="el-icon-plus el-icon-left"></i>新增同事名片
            </el-button>
          </div>
          <div class="table-body">
            <el-table
              :data="tableData"
              style="width: 100%;"
              border
              :row-key="(row) => { return row.id }"
            >
              <el-table-column
                prop="proImg"
                label="头像"
                width="300px"
              >
                <template v-slot="scope">
                  <div class="portrait-img">
                    <mk-iconfont
                      icon-class="paixu"
                      class="icon-rank"
                    ></mk-iconfont>
                    <img
                      src="https://avatar-static.segmentfault.com/198/713/1987139774-59c8bdbc3b36b_big64"
                      alt="error"
                      width="36"
                      height="36"
                    />
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="姓名">
                <template v-slot="scope">
                  {{ scope.row.profile.name }}
                </template>
              </el-table-column>
              <el-table-column label="职位">
                <template v-slot="scope">
                  {{ scope.row.profile.position }}
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template v-slot="scope">
                  <el-popover
                    v-model="scope.row.popoverVisible"
                    placement="top"
                    width="200"
                    trigger="click"
                    popper-class="my-colleague-popover"
                  >
                    <div>
                      <div><i class="el-icon-warning"></i>是否移除此同事？</div>
                      <div class="popover-button">
                        <el-button
                          size="mini"
                          @click="scope.row.popoverVisible = false"
                        >
                          取消
                        </el-button>
                        <el-button
                          size="mini"
                          type="primary"
                          @click="removeWorkmate(scope.row.id)"
                        >
                          确定
                        </el-button>
                      </div>
                    </div>
                    <a
                      slot="reference"
                      href="javascript: void(0)"
                    >移除</a>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-main>
    </el-container>
    <el-dialog
      v-loading="loading"
      title="选择同事"
      :visible.sync="drawer"
      :append-to-body="true"
      width="520"
      class="dialog"
    >
      <div>
        <div class="choose-input">
          <mk-input
            v-model="drawerInput"
            size="small"
            width="180"
            placeholder="输入姓名/职位"
            suffix-icon="el-icon-search"
          ></mk-input>
        </div>
        <div class="dialog-table">
          <el-table
            ref="multipleTable"
            v-infinite-scroll="load"
            :infinite-scroll-immediate="false"
            :data="drawerTableData"
            :row-key="(row) => {return row.id}"
            class="dialog-table-workmate"
            header-row-class-name="dialog-table-workmate-header"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              :reserve-selection="true"
              :selectable="canSelect"
              width="55"
            >
            </el-table-column>
            <el-table-column label="头像">
              <template v-slot="scope">
                <div class="portrait-img">
                  <img
                    :src="scope.row.gravatar"
                    alt="error"
                    width="36"
                    height="36"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column label="姓名">
              <template v-slot="scope">
                {{ scope.row.profile.name }}
              </template>
            </el-table-column>
            <el-table-column label="职位">
              <template v-slot="scope">
                {{ scope.row.profile.position }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="can-add">
          还可添加{{ canAdd }}个同事
        </div>
        <div class="drawer-button">
          <div class="has-choosen">
            已选中{{ selectedLength }}条
          </div>
          <div>
            <el-button
              size="mini"
              @click="drawer = false"
            >
              取消
            </el-button>
            <el-button
              type="primary"
              size="mini"
              @click="addWorkmate"
            >
              添加
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
export default {
  name: 'MyColleague',
  props: {
    formData: {
      type: Object,
      default: () => {
        return {
          isActive: true,
          workmateArr: []
        }
      }
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // table数据
      tableData: [],
      // 弹框table数据
      drawerTableData: [],
      // 弹框
      drawer: false,
      // 弹框输入框
      drawerInput: '',
      pageNum: 1,
      totalPage: 1,
      // 是否是第一次打开弹窗
      fistOpen: true,
      // 当前用户同事数组
      idList: [],
      // checkbox数据
      multipleSelection: [],
      // 1排序 2移除 3添加同事
      type: 1,
      // 是否正在加载
      loading: false
    }
  },
  computed: {
    selectedLength () {
      return this.multipleSelection.length
    },
    // 还能添加多少同事
    canAdd () {
      return 5 - this.idList.length
    }
  },
  watch: {
    formData (newVal, oldVal) {
      this.idList = this._.cloneDeep(newVal.workmateArr)
      this.cardWorkmateListArrayPost(this.idList)
    }
  },
  mounted () {
    this.rowDrop()
  },
  methods: {
    // 移除同事
    removeWorkmate (id) {
      const index = this.idList.indexOf(id)
      this.tableData[index].popoverVisible = false
      this.idList.splice(index, 1)
      this.type = 2
      const data = {
        workmateArr: this.idList
      }
      this.saveInfo(data)
    },
    // 添加同事
    addWorkmate () {
      let addList = []
      this.multipleSelection.forEach(item => {
        addList.push(item.id)
      })
      this.type = 3
      const data = {
        workmateArr: addList
      }
      this.saveInfo(data)
    },
    canSelect (row, index) {
      // if (this.canAdd === 0) {
      //   return false
      // } else {
      //   if (this.idList.indexOf(row.id) !== -1) {
      //     this.$refs.multipleTable.toggleRowSelection(row, true)
      //     return false
      //   } else {
      //     return true
      //   }
      // }
      return true
    },
    // 选择变化时
    handleSelectionChange (val) {
      this.multipleSelection = val
      if (this.selectedLength >= 6) {
        this.$message.error(`最多再添加${this.canAdd}个同事`)
        this.toggleSelection(val)
      }
    },
    // 切换选择
    toggleSelection (rows) {
      if (rows) {
        rows.forEach((row, index) => {
          this.$refs.multipleTable.toggleRowSelection(row, true)
          if (index >= 5) {
            this.$refs.multipleTable.toggleRowSelection(row, false)
          }
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    // 行拖拽
    rowDrop () {
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      const _this = this
      Sortable.create(tbody, {
        handle: '.icon-rank',
        onEnd: ({ newIndex, oldIndex }) => {
          const currRow = this.idList.splice(oldIndex, 1)[0]
          this.idList.splice(newIndex, 0, currRow)
          this.type = 1
          let data = {
            workmateArr: this.idList
          }
          this.saveInfo(data)
        }
      })
    },
    // 保存信息
    async saveInfo (data) {
      data.isActive = this.formData.isActive
      this.loading = true
      let res = await JINGTUIAPIS.CardApi.cardPut(
        {
          id: this.id
        },
        {
          workmate: data
        }
      )
      this.loading = false
      if (res.success) {
        if (this.type === 1) {
          this.$message.success('排序成功')
        } else if (this.type === 2) {
          this.$message.success('移除成功')
        } else {
          this.$message.success('添加成功')
          this.drawer = false
        }
        this.idList = res.data[0].workmate.workmateArr
        this.cardWorkmateListArrayPost(this.idList)
      } else {
        if (this.type === 1) {
          this.$message.error('排序失败')
        } else if (this.type === 2) {
          this.$message.error('移除失败')
        } else {
          this.$message.error('添加失败')
        }
      }
    },
    // 打开弹框
    openDialog () {
      this.drawer = true
      if (this.canAdd === 0) {
        this.$message.error('最多选择五个同事')
      }
      this.fistOpen = true
      this.drawerTableData = []
      this.pageNum = 1
      this.multipleSelection = []
      this.cardWorkmateListGet(this.pageNum)
    },
    // 根据id查询同时列表
    async cardWorkmateListArrayPost (arr) {
      let res = await JINGTUIAPIS.CardApi.cardWorkmateListArrayPost({
        idArr: arr
      })
      if (res.success) {
        this.tableData = res.data ? res.data : []
      }
    },
    // 弹框同时列表查询
    async cardWorkmateListGet (tarPage) {
      this.loading = true
      let res = await JINGTUIAPIS.AllApi.cardWorkmateListGet({
        page: tarPage
      })
      this.loading = false
      if (res.success) {
        this.drawerTableData = [...this.drawerTableData, ...res.data.list]
        this.totalPage = Math.ceil(res.data.total / res.data.pageSize)
      } else {
        this.pageNum--
      }
    },
    // 无线滚动
    load () {
      if (this.fistOpen) {
        this.fistOpen = !this.fistOpen
        return
      }
      if (this.pageNum >= this.totalPage) {
        return
      }
      this.cardWorkmateListGet(++this.pageNum)
    }
  }
}
</script>

<style lang="scss" scoped>
.my-colleague {
  background-color: #fff;
  width: 100%;

  a {
    text-decoration: none;
    color: #009cff;
  }

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .colleague-table {
    .table-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .header-reminder {
        font-size: 13px;
        color: #595959;
      }
    }

    .table-body {
      margin-top: 30px;

      .icon-rank {
        margin-right: 20px;
      }

      .portrait-img {
        display: flex;
        align-items: center;
      }
    }
  }
}

.dialog {
  .dialog-table-workmate {
    width: 100%;
    overflow: auto;
    max-height: 500px;
  }

  /deep/ .el-dialog__body {
    padding: 0;
  }

  .choose-input,
  .dialog-table {
    padding: 20px 20px 0;
  }

  .pagination {
    display: flex;
    margin-top: 20px;
    justify-content: flex-end;
  }

  .can-add {
    color: #8c8c8c;
    font-size: 13px;
    padding: 14px 20px 46px;
  }

  /deep/ .dialog-table-workmate-header {
    .el-checkbox {
      display: none;
    }
  }

  .drawer-button {
    height: 56px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 -2px 4px 0 rgba(5, 49, 38, 0.05);
    border: 1px solid rgba(232, 232, 232, 1);
    padding: 0 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .has-choosen {
      color: #8c8c8c;
      font-size: 13px;
    }
  }
}

/deep/ .el-icon-warning {
  color: #faad14;
}
</style>

<style lang="scss">
.my-colleague-popover {
  .popover-button {
    text-align: right;
    padding: 12px 0 0 0;
  }
}
</style>
